import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { EmployeeService } from "../services/employee.service";
import { SubSink } from "subsink";
import { IEmployeeHistory } from "../shared/models/EmployeeHistory";
import { PpsUtilityService } from "../services/pps-utility.service";
import { EmployeeBase } from "../shared/models/employee-base";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "pps-employee-history",
  templateUrl:"./employee-history.component.html"
})
export class EmployeeHistoryComponent implements OnInit, OnDestroy{
  @Input() employeeId?: number = null;

  spinnerName: string = "loading_emplyment_history";
  employeeHistory: IEmployeeHistory[] = [];
  context:any = {};
  gridHeaders = [];
  gridOptions = {
    defaultColDef:{
      resizable: true
    }
  };

  private subs = new SubSink();
  
  constructor(
    private _employeeService: EmployeeService,
    private _util: PpsUtilityService,
    private _spinner: NgxSpinnerService
  ){

  }


  ngOnInit(){
    if (this.employeeId > 0){
      this.context = { componentParent: this };
      this.gridHeaders = this.getColumnDefs();
  
      this.getEmployeeHistory(this.employeeId)
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private getEmployeeHistory(employeeId:number){
    this._spinner.show(this.spinnerName);
    this.subs.sink = this._employeeService
      .getEmployeeHistory(employeeId)
      .subscribe(response => {
        if (response.succeed){
          this.employeeHistory = response.result;
        }

        this._spinner.hide(this.spinnerName);
      })
      .add(() => this._spinner.hide(this.spinnerName));
  }

  private getColumnDefs(){
    return [
      {
        headerName: 'Id',
        field:'id',
        sortable: true,
        width: 40,
        cellStyle:{textAlign:'right'}
      },
      {
        headerName: 'Activity',
        field:'activity',
        sortable: false,
        width: 140
      },
      {
        headerName: 'Activity Date',
        field:'activityDate',
        sortable: true,
        width: 80,
        cellStyle:{textAlign:'right'},
        valueGetter: this.getDateValue
      },
      {
        headerName: 'Add By',
        sortable: false,
        width: 100,
        valueGetter: this.getAddByName
      },
      {
        headerName: 'Add Date',
        field:'addDate',
        sortable: false,
        width: 80,
        valueGetter: this.getDateValue
      },
      {
        headerName: 'Note',
        field:'note',
        sortable: false,
        width: 240
      }
    ];
  }  
  private getDateValue(params){
    if (params.data[params.colDef.field]){
      let value = params.context.componentParent._util.getDateString(params.data[params.colDef.field]);
      return value;
    }

    return "";
  }  

  private getAddByName(params){
    let emp: EmployeeBase = {
      firstName: params.data["addByFirstName"],
      lastName: params.data["addByLastName"]
    };
    
    let value = params.context.componentParent._util.getEmployeeName(emp);
    return value;
  }  
}